import { useMutation, useQueryClient } from 'react-query';
import { createCommunication } from 'App/services/RMSService';

const useCreateReferralCommunicationMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(
        ({ patientId, referralId, body }) => {
            return createCommunication(patientId, referralId, body);
        },
        {
            onSuccess: (_communication, variables) => {
                const queryPatientId = variables?.patientId;
                const queryReferralId = variables?.referralId;

                if (!queryPatientId || !queryReferralId) {
                    return undefined;
                }

                return queryClient.refetchQueries([
                    'patient',
                    queryPatientId,
                    'referral',
                    queryReferralId,
                    'communication',
                ]);
            },
        }
    );
};

export default useCreateReferralCommunicationMutation;
